import React, { memo } from 'react';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';
import { CommonIconProps, SvgIcon } from '@front/common/src/types/components';
import { findIcon } from '@front/common/src/utils/icons';

import iconSet from './selection.json';

const Svg = styled.svg<{
  $size: number;
}>`
  width: ${(props) => toRem(props.$size)};
  height: ${(props) => toRem(props.$size)};
  display: inline-block;
  vertical-align: middle;
`;

const Path = styled.path<{
  $color?: string;
}>`
  fill: ${(props) => props.$color};
`;

export const iconList = () => iconSet.icons.map((icon) => icon.properties.name.split(', ')[0]);

const renderPath = (iconObj: SvgIcon, color?: string) => (path: string, index: number) => {
  const attrs = (iconObj.icon.attrs && iconObj.icon.attrs[index]) || {};
  return <Path $color={color} key={index} d={path} {...attrs} />;
};

type IconProps = CommonIconProps & {
  title?: string;
  className?: string;
};

const Icon = ({ name, size, color, title, className }: IconProps) => {
  const currentIcon = findIcon(name, iconSet);

  return (
    <Svg
      $size={size}
      viewBox={`0 0 ${currentIcon.icon.width || '1024'} 1024`}
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
      role='img'
      className={className}
    >
      {title && <title>{title}</title>}
      {currentIcon.icon.paths.map(renderPath(currentIcon, color))}
    </Svg>
  );
};

export default memo(Icon);
